import Career from 'wwg-utilities/dist/collections/career';
import getSalaryPerYear from 'wwg-utilities/dist/sharedFunctions/getSalaryPerYear';
import { RIASEC } from 'wwg-utilities/dist/types/riasec-type';
import { getRequiredEducation, getTrainingType } from '../../../lib/careers';
import { isSkillup } from '../../../lib/config/project/project';
import Ballot from '../../icons/Ballot';
import DallasTrainingLength from '../../icons/DallasTrainingLength';
import Riasec from '../../icons/RIASEC';
import Salary from '../../icons/Salary';
import HoverOverInfo from '../../shared/HoverOverInfo';
import RiasecInfo from '../RiasecInfo';

interface CareerInfoProps {
  career: Career;
}

const CareerInfo: React.FC<CareerInfoProps> = ({ career }) => {
  return (
    <>
      {isSkillup ? (
        <>
          <section className="flex flex-wrap items-center justify-between col-start-1 row-start-5 border-solid md:block md:my-8 md:col-start-2 md:row-start-2 md:row-end-4 md:mx-4 md:border-0 border-t-1 border-b-1 border-white/50">
            {career.riasec.map((quality: string) => (
              <figure key={quality} className="flex items-center my-4">
                <Riasec
                  quality={quality.toLowerCase()}
                  className="w-6 h-6 fill-white"
                />
                &nbsp;&nbsp;
                <div className="relative font-medium text-white border-white border-dashed border-b-1 font-base">
                  <HoverOverInfo
                    text={quality}
                    textClass={'text-white'}
                    borderClass={'border-careers'}
                  >
                    <div className="md:w-[300px] p-4 bg-white border-solid text-careers border-1 border-careers rounded-3xl">
                      <RiasecInfo
                        quality={quality.toLowerCase() as RIASEC}
                        hoverClass={''}
                      />
                    </div>
                  </HoverOverInfo>
                </div>
              </figure>
            ))}
          </section>
          <section className="flex flex-wrap items-center col-start-1 row-start-3">
            <figure className="flex items-center flex-50 shrink-0">
              <Salary className="w-6 h-6 fill-white" /> &nbsp;&nbsp;&nbsp;
              <figcaption className="font-bold text-white capitalize md:text-xl font-base">
                {getSalaryPerYear(career.wageData.medianAnnualSalary)}
              </figcaption>
            </figure>
            <figure className="flex items-center my-4 flex-50">
              <DallasTrainingLength className="w-6 h-6 fill-white" />{' '}
              &nbsp;&nbsp;&nbsp;
              <figcaption className="font-bold text-white md:text-xl font-base whitespace-nowrap">
                {getTrainingType(career.trainingType)}
              </figcaption>
            </figure>
            <figure className="flex items-center lg:my-4 flex-50">
              <Ballot className="w-6 h-6 fill-white" /> &nbsp;&nbsp;&nbsp;
              <figcaption className="font-bold text-white md:text-xl font-base">
                {getRequiredEducation(career.trainingType)}
              </figcaption>
            </figure>
          </section>
          <section className="col-start-1 row-start-4 my-8">
            <p className="text-lg text-left text-white md:text-lg font-base">
              <span className="font-bold">Also known as:</span> <br />
              {career.alsoKnownAs}
            </p>
          </section>
        </>
      ) : (
        <section className="flex flex-wrap items-center my-8 border-solid md:mx-4 md:block justify-evenly border-t-1 border-b-1 border-white/50">
          {career.riasec.map((quality: string, index: number) => {
            return (
              <figure
                key={`quality-${index}`}
                className="flex items-center mx-4 my-4 md:mx-0"
              >
                <Riasec
                  quality={quality.toLowerCase()}
                  className="w-6 h-6 fill-white"
                />
                &nbsp;&nbsp;
                <figcaption className="font-medium text-white">
                  {quality}
                </figcaption>
              </figure>
            );
          })}
        </section>
      )}
    </>
  );
};

export default CareerInfo;
